export default __webpack_public_path__ + "static/media/heart.9ca8fd9a.svg";